<template>
  <div class="act-apl">
    <div class="form-ipt">
      <div class="input">
        <!-- <sign-title title="家长信息" />
        <van-cell title="家长信息" required>
          <template #right-icon>
            <van-icon name="certificate" color="#16d77a" size="24" />
          </template>
        </van-cell> -->
        <!-- <sign-title title="选手信息" /> -->
        <div class="reject" v-if="worksType == 1 || worksType == 2">
          <p>修改到期时间：{{ rejectUpdTime }}</p>
          <p>驳回理由：{{ rejectReason }}</p>
        </div>
        <van-field v-if="model == 1"
          input-align="right"
          readonly
          clickable
          name="subject"
          required
          :disabled="formData.workId?true:false"
          :value="subject"
          label="参赛主体"
          placeholder="请选择主体"
          @click="formData.workId ? '' : (subjectShow = true)"
          error-message-align="right"
          :error-message="validate.fieldMsg.subject"
        />
        <van-popup v-model="subjectShow" position="bottom">
          <van-picker
            show-toolbar
            :columns="subjectList"
            @confirm="subjectAdd"
            @cancel="subjectShow = false"
          />
        </van-popup>
        <van-field label-width="100" input-align="right" clickable name="name" required v-model="name" label="姓名" 
          maxlength="12" placeholder="请输入姓名" error-message-align="right"/>
        <van-field label-width="100" input-align="right" clickable name="phone" required v-model="phone"
          label="手机号" maxlength="12" placeholder="请输入手机号" error-message-align="right"/>
        <van-field name="radio" label="身份证号类型" required input-align="right">
          <template #input>
            <van-radio-group v-model="idCardType" direction="horizontal">
              <van-radio name="0">内地</van-radio>
              <van-radio name="1">港澳台及外籍</van-radio>
            </van-radio-group>
          </template>
        </van-field>
        <van-field label-width="100" input-align="right" clickable name="phone" required v-model="idCardNo"
          label="身份证号" maxlength="12" placeholder="请输入身份证号" error-message-align="right"/>

        <van-field v-if="idCardType==1" input-align="right" readonly required clickable name="cardType" label="出生日期"
          v-model="birthday" placeholder="点击选择出生日期" error-message-align="right"
          @click="showBirthday=true"
        />
        <van-popup v-model="showBirthday" position="bottom">
          <van-datetime-picker
            type="date"
            title="选择年月日"
            :min-date="minDate"
            :max-date="new Date()"
            @cancel="showBirthday = false"
            @confirm="getbirthday"
          />
        </van-popup>
        <van-field v-if="idCardType==1" readonly disabled input-align="right" clickable name="age" v-model="age" type="digit" label="年龄" placeholder="选择出生日期自动生成"/>
        <van-field v-if="idCardType==1" input-align="right" readonly required clickable :value="sex" name="sex" label="学生性别"
          placeholder="点击选择性别" @click="showPicker = true"
        />
        <van-popup v-model="showPicker" position="bottom">
          <van-picker show-toolbar @cancel="showPicker = false"
            :columns="[{ text: '男', value: 1},{ text: '女', value: 2}]"
            @confirm="(e)=>{sex=e.text;sexVal=e.value,showPicker=false}"
          />
        </van-popup>
        <van-field
          v-if="model == 0||subject == '个人'||subject == '团体'"
          readonly
          clickable
          name="playerVal"
          input-align="right"
          required
          :value="zoneName"
          label="所在赛区"
          :error="subjectList.length === 0"
          placeholder="选择赛区"
          @click=" institutionId != 0 || worksType == 1 || worksType == 2 ||(subject == '团体' && id)?'':(provincesShow = true)"
          error-message-align="right"
          :error-message="validate.fieldMsg.playerVal"
        />
        <van-popup v-model="provincesShow" position="bottom">
          <van-picker
            value-key='areaName'
            show-toolbar
            :columns="provincesArr"
            @confirm="provincesAdd"
            @cancel="provincesShow = false"
          />
        </van-popup>
        <van-field
          v-if="model == 0 && institutionName"
          input-align="right"
          clickable
          v-model="teacherName"
          label="指导老师"
          :disabled="id != ''"
          maxlength="12"
          placeholder="请输入指导老师"
          error-message-align="right"
          :error-message="validate.fieldMsg.teacherName"
        />
        <van-field
          v-if="model == 0 && institutionName"
          label-width="100"
          input-align="right"
          clickable
          :disabled="id != ''"
          v-model="teacherTel"
          label="指导老师手机号"
          maxlength="12"
          placeholder="请输入指导老师手机号"
          error-message-align="right"
        />
        <van-field
          v-if="subject == '团体'"
          input-align="right"
          clickable
          name="teamName"
          required
          v-model="formData.teamName"
          label="团体名称"
          maxlength="12"
          placeholder="请输入团体名称"
          error-message-align="right"
          :error-message="validate.fieldMsg.teamName"
        />
        <van-field
          v-if="subject == '团体'"
          input-align="right"
          required
          label="团体成员"
          error-message-align="right"
        >
          <template #input>
            <van-button round type="primary" @click="addUser" size="small">添加</van-button>
          </template>
        </van-field>
        <div class="overallWrap-Left" style="background-color: #fff; max-width: 100vw;">
          <div class="photo-upload" v-for="(item, index) in formData.list" :key="'t'+index">
            <van-tag
              style="padding: 10px"
              :show="true"
              closeable
              size="medium"
              type="primary"
              color="#f2f2f2"
              text-color="#333"
              @close="closeTag(index)"
            >
              {{ item.name }}（{{ item.phone }}）
            </van-tag>
          </div>
        </div>

        <van-field
          input-align="right"
          readonly
          clickable
          name="majorVal"
          required
          :value="major"
          :label="model == 0 ? '选择专业' : '选择类型'"
          :placeholder="model == 0 ? '请选择专业' : '请选择类型'"
          @click="worksType == 1 || worksType == 2 ? '' : (majorShow = true)"
          error-message-align="right"
          :error-message="validate.fieldMsg.majorVal"
        />
        <van-popup v-model="majorShow" position="bottom">
          <van-picker show-toolbar :columns="majorColumns" @confirm="majorConfirm" @cancel="majorShow = false"/>
        </van-popup>
        <van-field
          label-width="100"
          input-align="right"
          clickable
          v-model="formData.schoolName"
          label="就读学校"
          placeholder="请输入就读学校"
          error-message-align="right"
        />


        <template v-if="activityId==28">
          <van-field
            input-align="right"
            readonly
            clickable
            name="groupVal"
            required
            :value="formData.province"
            label="选择地区"
            placeholder="选择地区"
            @click="provinceShowFn = true"
            error-message-align="right"
            :error-message="validate.fieldMsg.groupVal"
          />
          <van-popup v-model="provinceShowFn" position="bottom">
            <van-picker show-toolbar :columns="areaListData" @confirm="getprovinceShowFn" @cancel="provinceShowFn = false"/>
          </van-popup>
        </template>


        <van-field
          v-if="formData.mainBodyType == 1"
          input-align="right"
          clickable
          name="mail"
          v-model="formData.mail"
          label="邮箱账号"
          placeholder="请输入邮箱便于接受通知"
          error-message-align="right"
        />

        <van-field
          input-align="right"
          clickable
          name="phone"
          required
          v-model="formData.phone"
          label="手机号码"
          placeholder="请输入手机便于接受通知"
          error-message-align="right"
          maxlength="11"
          :error-message="validate.reg_verify_err_msg.phone || validate.fieldMsg.phone"
          @change="validate.tel('phone')"
          :style="{ marginBottom: '20px' }"
        />

        <van-field
          input-align="right"
          clickable
          name="photo_title"
          required
          v-model="formData.photo_title"
          label="作品名称"
          maxlength="12"
          placeholder="请输入12字内作品名称"
          error-message-align="right"
          :error-message="validate.fieldMsg.photo_title"
        />
       <!-- <van-field
          v-if="subject == '团体'"
          input-align="right"
          clickable
          name="school"
          :disabled="isInst"
          v-model="formData2.unitName"
          label="报名服务单位"
          :maxlength="20"
          placeholder="请输入报名服务单位"
        /> -->

        <van-field
          input-align="right"
          clickable
          required
          name="teacher"
          v-model="formData2.teacherName"
          label="指导老师"
          :disabled="isInst"
          placeholder="请输入报名服务单位指导老师姓名"
          v-if="formData2.unitName && subject == '团体'"
          error-message-align="right"
          :error-message="validate.fieldMsg.teacher"
        />

        <van-field input-align="right" clickable required name="teacher_phone" :disabled="isInst" v-model="formData2.teacherPhone"
          label="指导老师手机号" placeholder="请输入指导老师手机号" v-if="formData2.unitName && subject == '团体'"
        />

        <van-field input-align="right" clickable name="photo_desc" required v-model="formData.photo_desc"
          autosize rows="4" type="textarea" maxlength="300" label="作品描述"
          placeholder="请输入作品描述，如创作动机、作品构思等" show-word-limit
          error-message-align="right" :error-message="validate.fieldMsg.photo_desc"
        />
        <template v-if="formData.imgsArr&&formData.imgsArr.length>0">
          <div v-for="(time,index) in formData.imgsArr" :key="index">
            <van-field input-align="right" label-class="affixs-label" label="作品文件" required error-message-align="right" :error-message="validate.fieldMsg.imgs">
              <template #label>
                <span class="custom-title">作品{{time.fileType==1?'图片':time.fileType==2?'音频':time.fileType==3?'视频':time.fileType==4?'文档':''}}文件</span>
                <div class="custom-tit">
                  <span v-if="time.formatInfo">{{ time.formatInfo }}格式不超过300M</span>
                </div>
              </template>
            </van-field>
            <div class="photo-upload">
              <van-uploader :accept="time.formatInfo" v-model="time.photo_file_list" :max-count="1" 
              :before-read="(file)=>photoBeforeRead(file,index)"
              />
            </div>
          </div>
        </template>

        <van-field
          v-if="sourceFileMust"
          input-align="right"
          label-class="affixs-label"
          label="源文件附件"
          :required="sourceFileMust"
          error-message-align="right"
          :error-message="validate.fieldMsg.sourceFile"
        >
          <template #label>
            <span class="custom-title">源文件附件</span>
            <span class="custom-tit">(如HUA、PSD、AI等源文件,且不超过50M) </span>
          </template>
        </van-field>
        <div class="file-upload" v-if="sourceFileMust">
          <van-uploader v-model="photo_affix_list" :max-count="1" :before-read="affixBeforeRead" accept="">
            <template #preview-cover>
              <div class="preview-cover van-ellipsis">
                {{ photo_affix_list[0].name }}
              </div>
            </template>
          </van-uploader>
        </div>
      </div>
      <div v-if="isCollection == 1">
        <sign-title title="收件信息" />
        <van-field
          input-align="right"
          clickable
          name="receivingUser"
          required
          v-model="formData.receivingUser"
          label="收件人"
          maxlength="12"
          placeholder="请输入收件人"
          error-message-align="right"
          :error-message="validate.fieldMsg.receivingUser"
        />
        <van-field
          input-align="right"
          clickable
          name="receivingPhone"
          required
          v-model="formData.receivingPhone"
          label="手机号"
          maxlength="12"
          placeholder="请输入收件人手机号"
          error-message-align="right"
          :error-message="validate.fieldMsg.receivingPhone"
          @change="validate.tel('receivingPhone')"
        />
        <van-field
          input-align="right"
          clickable
          name="receivingCode"
          required
          v-model="formData.receivingCode"
          label="邮编"
          placeholder="请输入邮编"
          error-message-align="right"
          :error-message="validate.fieldMsg.receivingCode"
        />
        <van-field
          input-align="right"
          clickable
          name="receivingDetailAddress"
          required
          v-model="formData.receivingDetailAddress"
          label="收件地址"
          placeholder="请输入收件地址"
          error-message-align="right"
          :error-message="validate.fieldMsg.receivingDetailAddress"
        />
      </div>
      <div class="tips">
        <div class="tip">
          <van-checkbox v-model="promise" icon-size="16px" />
          <p>我已阅读并同意《<span @click="getPageContent(5)">作品原创承诺书</span>》</p>
        </div>
        <div class="tip">
          <van-checkbox v-model="mandate" icon-size="16px" />
          <p>我已阅读并同意《<span @click="getPageContent(6)">作品授权书</span>》</p>
        </div>
      </div>
      <div class="submit" v-if="modifiableType == 1 && worksType == 0">
        <van-button size="large" @click="submitFn" color="linear-gradient(to right, #5DD682, #5AFF8E)" :disabled="btndis">提交</van-button>
      </div>
      <div class="submit" v-if="modifiableType == 0 || worksType == 1 || worksType == 2">
        <van-button size="large" @click="editFn" color="linear-gradient(to right, #5DD682, #5AFF8E)">修改</van-button>
      </div>
    </div>
    <van-popup v-model="applySuccess" position="right" :style="{ height: '100%', width: '100%' }">
      <div class="apply-success">
        <div class="tip-info">
          <img src="../../assets/images/home/apply-success.png" alt="" />
          <p>{{isLabelPrint == 1?'恭喜您，报名成功！':'恭喜！您已提交成功。请关注评审结果'}}</p>
        </div>
        <div class="successTips" v-if="isLabelPrint == 1">
          <div>
            1.报名成功后，作品须提交原件至报名的赛区组委会，不提供参赛作品原件者不得参与比赛评审；
          </div>
          <div>
            2.参赛者提交的原件作品须在作品背面按照服务平台要求粘贴参赛信息标签；<span @click="getLabel">如何获取并张贴标签？</span>
          </div>
          <div>
            3.为增加本届参赛选手参与社会实践的体验感，本届比赛所有参赛者均可申领电子版社会实践证明。
          </div>
        </div>
        <!-- <div class="view-btn">
          <van-button size="large" color="linear-gradient(to right, #5DD682, #5AFF8E)" @click="viewWorks">查看作品</van-button>
        </div> -->
        <div class="overallCenter know" @click="getknow">我知道了</div>
      </div>
    </van-popup>
    <van-popup v-model="consentPage" position="right" :style="{ height: '100%', width: '100%' }">
      <m-loading :loading="!pageContent"> </m-loading>
      <div class="consent-page">
        <h2>{{ pageTitle }}</h2>
        <div class="container" v-html="pageContent"></div>
        <div class="consent-btn">
          <van-button size="large" color="linear-gradient(to right, #5DD682, #5AFF8E)" @click="confirmRead">我已认真阅读</van-button>
        </div>
      </div>
    </van-popup>
    <van-dialog v-model="showAdd" :before-close="listAddUser" title="新增团体成员" show-cancel-button>
      <div style="padding:20PX 10px">
        <van-field label-width="100" input-align="right" clickable name="name" required v-model="name" label="姓名" 
          maxlength="12" placeholder="请输入姓名" error-message-align="right"/>
        <van-field label-width="100" input-align="right" clickable name="phone" required v-model="phone"
          label="手机号" maxlength="12" placeholder="请输入手机号" error-message-align="right"/>
        <van-field name="radio" label="身份证号类型" required input-align="right">
          <template #input>
            <van-radio-group v-model="idCardType" direction="horizontal">
              <van-radio name="0">内地</van-radio>
              <van-radio name="1">港澳台及外籍</van-radio>
            </van-radio-group>
          </template>
        </van-field>
        <van-field label-width="100" input-align="right" clickable name="phone" required v-model="idCardNo"
          label="身份证号" maxlength="12" placeholder="请输入身份证号" error-message-align="right"/>

        <van-field v-if="idCardType==1" input-align="right" readonly required clickable name="cardType" label="出生日期"
          v-model="birthday" placeholder="点击选择出生日期" error-message-align="right"
          @click="showBirthday=true"
        />
        <van-popup v-model="showBirthday" position="bottom">
          <van-datetime-picker
            type="date"
            title="选择年月日"
            :min-date="minDate"
            :max-date="new Date()"
            @cancel="showBirthday = false"
            @confirm="getbirthday"
          />
        </van-popup>
        <van-field v-if="idCardType==1" readonly disabled input-align="right" clickable name="age" v-model="age" type="digit" label="年龄" placeholder="选择出生日期自动生成"/>
        <van-field v-if="idCardType==1" input-align="right" readonly required clickable :value="sex" name="sex" label="学生性别"
          placeholder="点击选择性别" @click="showPicker = true"
        />
        <van-popup v-model="showPicker" position="bottom">
          <van-picker show-toolbar @cancel="showPicker = false"
            :columns="[{ text: '男', value: 1},{ text: '女', value: 2}]"
            @confirm="(e)=>{sex=e.text;sexVal=e.value,showPicker=false}"
          />
        </van-popup>
      </div>
    </van-dialog>
    <Crop :popup.sync="compressShow" :img="compressImg" @close="cancelUpload" @getImageData="uploadHead"/>
  </div>
</template>

<script>
import Crop from "@/components/pub/CompressCrop.vue";
import SignTitle from "@/components/pub/SignTitle.vue";
import { validate } from "@/utils/mixin/validate";
import { areaList } from "@vant/area-data";
import {
  activityEnroll,
  updWorks,
  getCurrentActivityMajor,
  sendReadingCode,
  getAllProvinces
} from "@/utils/api/home";
import {
  getWorksDetails,
  uploadImg,
  uploadFile,
  getArticleDetails,
  getswActivityDetail
} from "@/utils/api/user";
import { checkUploadFile,getfileTypeArr } from "@/utils/tool";
import {getGrowAge} from "@/utils/yearOld";
export default {
  mixins: [validate],
  components: {
    Crop,
    "sign-title": SignTitle
  },

  data() {
    return {
      areaList,
      areaListData:[],
      id: "",
      institutionName: "",
      institutionId: "",
	  
      teacherName: "",
      teacherTel: "",
      isCollection: "",
      formatInfo: "",
      activityId: "",
      model: 2,
      // 团体添加学生字段
      name: "",
      phone: "",
      idCardNo: null,
      idCardType:'0',
      showBirthday:false,
      birthday:null,
      age:null,
      minDate: new Date(),
      showPicker:false,
      sex:'',
      sexVal:'',
      
      showAdd: false,
      // 主体
      subjectShow: false,
      subjectList: [
        { text: "个人", value: "1" },
      ],
	    cardType:'',
	    showtypePicker:false,
      subject: "",
      // 选手名称
      player: null,
      // 赛区
	    zoneName:null,
      // 显示选择专业
      majorShow: false,
      // 专业名称
      major: null,
      // 专业列表
      majorColumns: [],
      // 作品文件
      photo_file_list: [],
      // 作品源文件
      photo_affix_list: [],
      // 同意承诺书
      promise: false,
      // 同意授权书
      mandate: false,
      // 需要提交的表单信息
      compressShow: false,
      compressImg: "",
      formData2: {
        // name: "",
        // age: null,
        // school: "",
        // organizationVal: null,
        // teacher: "",
        // teacher_phone: ""
      },
      // 提交数据
      formData: {
        schoolName:'',
        list: [],
        receivingUser: null,
        receivingPhone: null,
        receivingDetailAddress: null,
        receivingCode: null,
        teamName: null,
        mainBodyType: null,
        playerVal: null,
        majorVal: null,
        phone:'',
        imgsArr:[],
        mail: null,
        photo_title: null,
        photo_desc: null,
        sourceFile: null,
        // 省
        province:null,
        // 赛区
		    zoneName:null,
        zoneId:'',
      },
      // 地区选择弹框
      provinceShowFn:false,

      formDataPhone:'',
      // 是否报名成功
      applySuccess: false,
      // 作品id
      worksId: null,
      // 需要源文件
      sourceFileMust: false,
      // 承诺书 授权书
      consentPage: false,
      pageTitle: "",
      // 页面内容
      pageContent: "",
      modifiableType: 1, // 1 不可修改  0 可修改
	    institutionId2:0, //0 可修改，其他值不可修改
      worksType: 0, // 0 正常 1 被驳回 2修改后  3 报名失败
      rejectReason: "",
      rejectUpdTime: "",
      btndis: false,
      isInst: false,
      // 赛区省数组
      provincesShow:false,
      provincesArr:[],
      // 是否出现 打印标签:改为是否出现提示
      isLabelPrint:0,
    };
  },
  async mounted() {
    this.areaListData = []
    for(let i in this.areaList.province_list){
      this.areaListData.push({text:areaList.province_list[i],value:i})
    }
    this.validate.setFormDataKey("formData");
    this.id = this.$route.query.id;
    let activityId = this.$route.query.activityId;
    let infos = {}
    if(activityId){
      // await getswActivityDetail(activityId).then(res=>{
      //   if(res.code == 20000){
      //     infos = res.data;
      //   }
      // })
    }else{
      infos = JSON.parse(window.localStorage.getItem("active_infos_data"));
    }
    if(infos.id !== 28){
      this.formData.province = this.$store.state.addressInfos.province;
    }
	  this.formData.zoneName = this.$store.state.addressInfos.province;
    if (infos) {
      this.activityId = infos.id;
      this.model = infos.model;
      this.isCollection = infos.isCollection;
      this.isLabelPrint = infos.isLabelPrint;
    }
    let rece = {
      receivingUser: null,
      receivingPhone: null,
      receivingDetailAddress: null,
      receivingCode: null
    };
    let teacher = {
      teacherName: null,
      teacherPhone: null,
      list: [],
      teamName: null
    };
    let userName = {
      playerVal: null
    };
    this.formData = {
      mainBodyType: 1,
      majorVal: null,
      mail: null,
      phone: null,
      photo_title: null,
      photo_desc: null,
      imgsArr:[],
      sourceFile: null
    };
    if (this.model == 1) {
      this.formData = { ...this.formData, ...teacher };
      this.subject = "个人";
    } else {
      this.formData = { ...this.formData, ...userName };
      this.subject = "";
    }
    if (this.isCollection == 1) {
      this.formData = { ...this.formData, ...rece };
    }
    if (this.id) {
      this.activityId = "";
    } else {
      const userInfo = this.$store.state.userInfo;
      this.formData.phone = userInfo.code
      // this.getPageSelectInfo();
    }
    this.AllProvinces()
  },
  beforeRouteLeave(to, from, next){
    if(to.name =='Login' && this.activityId){
      next({name: 'HomeIndex'});
    }else {
      next(); // 注意：这边next必须要写
    }
  },
  methods: {
    /**
     * @description: 获取省数据
     * @author: wangxiaoheng
     */
    AllProvinces(){
      getAllProvinces(this.activityId).then((res) => {
        if (res.success) {
          this.provincesArr = res.data
        }
      })
    },
    // 年龄限制
    ageLimit(val) {
      if (parseInt(val) > 30) {
        this.age = 30;
      }
      if (parseInt(val) < 1) {
        this.age = 1;
      }
    },
    getbirthday(date){
      let Y = date.getFullYear() + '-';
      let M = (date.getMonth()+1 < 10 ? '0'+(date.getMonth()+1) : date.getMonth()+1) + '-';
      let D = (date.getDate() < 10 ? '0'+date.getDate(): date.getDate());
      this.birthday = Y+M+D;
      this.age = getGrowAge( this.birthday).gapYear;
      this.ageLimit(this.age)
      this.showBirthday = false;
    },

    // 获取作品信息
    async testDataInput() {
      await getWorksDetails(this.id).then((res) => {
        if (res.success) {
          let info = res.data;
          this.major = info.majorName;
          this.model = info.activityType;
          this.activityId = info.activityId;
          this.isCollection = info.isCollection;
		      this.player = info.babyName;
          this.province = info.province;
		      this.zoneName = info.zoneName;
		  
          if (this.model === 0) {
            this.institutionName = info.institutionName;
            this.teacherName = info.memo1;
            this.teacherTel = info.memo2;
          }
          if (info.institutionName && info.memo1 && info.memo2) this.isInst = true;
          this.photo_affix_list = [
            {
              url: info.sourceFile,
              name: info.sourceFile,
              status: "done"
            }
          ];
          this.modifiableType = info.modifiableType;
          this.rejectUpdTime = info.rejectUpdTime;
          this.rejectReason = info.rejectReason;

          this.worksType = info.worksType;
		      this.institutionId2=info.institutionId //值为0非团体 可修改
 		  
          let teacher = {
            teamName: info.babyName,
            list: info.list
          };
          let rece = {
            receivingUser: info.receivingUser,
            receivingPhone: info.receivingPhone,
            receivingDetailAddress: info.receivingDetailAddress,
            receivingCode: info.receivingCode
          };
          this.formData2 = {
            unitName: info.institutionName,
            babyName: info.babyName,
            organizationVal: null,
            teacherName: info.memo1,
            teacherPhone: info.memo2
          },
          this.formData = {
            schoolName: info.schoolName,
            mainBodyType: info.mainBodyType,
            majorVal: info.majorId,
            photo_title: info.name,
            photo_desc: info.synopsis,
            province: info.province,
			      imgsArr:getfileTypeArr(info.imgs),
            sourceFile: info.sourceFile,
            workId: this.id,
            phone:info.tel,
            zoneId:info.zoneId,
			      zoneName: info.zoneName,
          };
          this.formDataPhone = this.formData.phone;
          this.formTeacherPhone = info.memo2;
          let typeInfo = {
            playerVal: info.babyId,
            mail: info.email
          };
          if(info.idCardType==0||info.idCardType==1){
            this.cardType = info.idCardType == 0 ? "内地" : "港澳台及外籍";
            this.formData2.cardType = info.idCardType
          }
          if (this.model == 1) {
            this.formData = { ...this.formData, ...teacher };
            this.subject = info.mainBodyType == 1 ? "个人" : "团体";
          } else {
            this.subject = "";
          }
          if (info.mainBodyType == 1) {
            this.formData = { ...this.formData, ...typeInfo };
          }
          if (this.isCollection == 1) {
            this.formData = { ...this.formData, ...rece };
          }
          
          this.getPageSelectInfo();
        }
      });
    },
    // 获取页面信息
    getPageSelectInfo() {
      // 获取专业 组别
      getCurrentActivityMajor({
        activityId: this.activityId
      }).then((res) => {
        if (res.success) {
          this.CurrentActivityMajor = res.data;
          let data = res.data.personalEnroll;
          if(res.data.groupEnroll&&res.data.groupEnroll.length>0){
            this.subjectList.push({
              text: "集体创作",
              value: "2",
            })
          }
          this.gethandle(data)
        }
      });
    },
    // 处理组别专业
    gethandle(data){
      data = data.map((e) => {
        return {
          text: e.majorName,
          value: e.majorId,
          gruop: e.childGroup,
          sourceFileMust: e.typeId == 1,
          fileTypeList: e.fileTypeList
        };
      });
      this.majorColumns = data
      for (let item of this.majorColumns) {
        if (item.value == this.formData.majorVal) {
          this.sourceFileMust = item.sourceFileMust;
          this.groupColumns = item.gruop.map((e) => {
            return {
              text: e.groupName,
              value: e.groupId
            };
          });
        }
      }
    },
    cancelUpload() {
      this.compressShow = false;
      this.head = [];
    },
    // 上传头像
    async uploadHead(file) {
      const pass = checkUploadFile({ file, size: 3 }, (err) => {
        this.$root.$toast.fail(err);
        this.head = [
          {
            url: "",
            message: "图片大于3m，请重新选择图片。",
            status: "failed",
            name: file.name
          }
        ];
      });
      if (!pass) {
        return;
      }
      this.head = [
        {
          url: "",
          status: "uploading",
          message: "上传中...",
          name: file.name
        }
      ];
      this.$forceUpdate();
      let upimgobj = new FormData();
      this.$root.$toast.loading({
        message: "上传图片中……",
        duration: 0
      });
      upimgobj.append("file", file);
      const { data: url, success } = await uploadImg(upimgobj);
      if (success) {
        this.head = [
          {
            url,
            status: "done",
            name: file.name
          }
        ];
        this.formData2.head = url;
      } else {
        this.head = [
          {
            url: "",
            message: "上传失败，请重新上传",
            status: "failed",
            name: file.name
          }
        ];
      }
      this.$forceUpdate();
      this.$root.$toast.clear();
    },
    ontypeConfirm(item){
      this.cardType = item.text;
      this.idCardNo=null;
      this.formData2.cardType = item.value;
      this.showtypePicker = false;
    },
    // end
    addUser() {
      let date = new Date()
      let Y = date.getFullYear();
      let M = (date.getMonth()+1 < 10 ? '0'+(date.getMonth()+1) : date.getMonth()+1);
      let D = (date.getDate() < 10 ? '0'+date.getDate(): date.getDate());
      this.minDate = new Date((Y-30), M, D)
      this.idCardNo = null;
      this.idCardType=null;
      this.showBirthday=false;
      this.birthday=null;
      this.age=0;
      this.showPicker = false;
      this.sex = '';
      this.sexVal = '';
      this.phone = "";
      this.name = "";
      this.showAdd = true;
    },
    listAddUser(action, done) {
      if (action === "confirm") {
        // 确认
        if (!this.name || !this.phone || !this.idCardNo) {
          this.$root.$toast.fail("请填写信息");
          done(false); // 关闭提⽰框
          return;
        }
        if(this.idCardType == 1){
          if (!this.birthday || !this.age || !this.sex) {
            this.$root.$toast.fail("请填写信息");
            done(false); // 关闭提⽰框
            return;
          }
        }
        let data = {
          name: this.name,
          phone: this.phone,
          idCardNo:this.$cryptojs.encryptionBase64(this.idCardNo),
          idCardType:this.idCardType,
        }
        if(data.idCardType==1){
          data.birthday = this.birthday;
          data.age = this.age;
          data.sex = this.sexVal;
        }
        this.formData.list.push(data);
        done(); // 关闭提⽰框
      } else if (action === "cancel") {
        // 取消
        done(); // 关闭提⽰框
      }
    },
    closeTag(e) {
      this.formData.list.splice(e, 1);
    },
    /**
     * @description: 赛区选择
     * @param {*} data  选中数据
     * @author: wangxiaoheng
     */
    provincesAdd(data){
      this.province = data.areaName;
	    this.zoneName = data.areaName;
      if(this.activityId !== 28){
        this.formData.province = data.areaName;
      }
		  this.formData.zoneName = data.areaName;
      this.formData.zoneId = data.id;
      this.provincesShow = false;
    },
    // 地区选择
    getprovinceShowFn(item){
      this.formData.province = item.text;
      this.provinceShowFn = false;
    },
    // 主体确认
    subjectAdd(item) {
      this.player = "";
      this.major = "";
      this.photo_affix_list = [];
      let rece = {
        receivingUser: null,
        receivingPhone: null,
        receivingDetailAddress: null,
        receivingCode: null
      };
      let teacher = {
        teacherName: null,
        teacherPhone: null,
        majorVal: null,
        list: [],
        teamName: null
      };
      let grop = {
        playerVal: null,
        majorVal: null,
        mail: null
      };
      this.formData = {
        mainBodyType: null,
        photo_title: null,
        photo_desc: null,
        sourceFile: null
      };

      if (item.value == 2) {
        this.formData = { ...this.formData, ...teacher };
      }
      if (item.value == 1) {
        this.formData = { ...this.formData, ...grop };
      }
      if (this.isCollection == 1) {
        this.formData = { ...this.formData, ...rece };
      }
      this.formData.imgsArr = [];
      this.formData.mainBodyType = item.value;
      this.subject = item.text;
      this.subjectShow = false;
    },
    // 专业确定
    majorConfirm(item) {
      this.major = item.text;
      this.formData.majorVal = item.value;
      this.majorShow = false;
      if (this.formData.mainBodyType == 1) {
        this.formData.groupVal = "";
      }
      this.sourceFileMust = item.sourceFileMust;
      this.formatInfo = "";
      this.formData.sourceFile = "";
      this.formData.imgsArr = []
      for(let k in item.fileTypeList){
        let kType = item.fileTypeList[k];
        let formatInfo = '';
        if(kType == 1){
          formatInfo = 'image/jpeg,image/png,image/jpg';
        }else if(kType==2){
          formatInfo = '.mp3,.wav,.ogg,.mpeg';
        }else if(kType==3){
          formatInfo = '.mp4,.avi,.mov';
        }else if(kType==4){
          formatInfo = '.doc,.docx';
        }
        this.formData.imgsArr.push({
          fileName:'',
          fileUrl:'',
          url:'',
          fileType:kType,
          formatInfo:formatInfo,
          photo_file_list:[]
        })
      }
      this.photo_affix_list = [];
    },
    // 图片上传
    photoBeforeRead(file,index) {
      let imgsArr = this.formData.imgsArr[index]
      const pass = checkUploadFile(
        { file, size: 300, type: imgsArr.fileType, typestr: imgsArr.formatInfo },
        (err) => {
          this.$root.$toast.fail(err);
        }
      );
      if (!pass) {
        return false;
      }
      this.formData.imgsArr[index].photo_file_list = [{
        message:"上传中...",
        status:'uploading',
      }]
      this.formData.imgsArr[index].url = '';
      let upimgobj = new FormData();
      upimgobj.append("file", file);
      uploadFile(upimgobj,this.activityId).then(({ success, data }) => {
        if (success) {
          this.formData.imgsArr[index].photo_file_list = [{
            status:"done",
            url:data.fileUrl,
          }]
          return success;
        } else {
          this.formData.imgsArr[index].photo_file_list = [{
            message:"上传失败，请重新上传",
            status:"failed",
            url:'',
          }]
          return success;
        }
      });
    },
    // 源文件上传
    affixBeforeRead(file) {
      const fileName = file.name;
      const pass = checkUploadFile(
        { file, size: 100, type: 1, typestr: -1 },
        (err) => {
          this.$root.$toast.fail(err);
        }
      );
      if (!pass) {
        return false;
      }
      this.photo_affix_list = [
        {
          url: "",
          status: "uploading",
          message: "上传中...",
          name: fileName
        }
      ];
      let upfileobj = new FormData();
      upfileobj.append("file", file);
      uploadFile(upfileobj,this.activityId).then(({ success, data }) => {
        if (success) {
          this.photo_affix_list = [
            {
              url: data.fileUrl, //
              name: fileName,
              status: "done"
            }
          ];
          this.formData.sourceFile = data.fileUrl;
          return success;
        } else {
          this.photo_affix_list = [
            {
              url: "",
              message: "上传失败，请重新上传",
              status: "failed"
            }
          ];
          return success;
        }
      });
    },
    // 获取承诺书授权书
    getPageContent(type) {
      if (type == 5) this.pageTitle = "作品原创承诺书";
      else this.pageTitle = "作品授权书";

      this.consentPage = true;
      this.pageContent = "";
      getArticleDetails(type).then((res) => {
        if (res.success) {
          this.pageContent = res.data;
        }
      });
    },
    confirmRead() {
      this.consentPage = false;
    },
    // 修改信息
    async editFn() {
      if (this.model == 1) {
        if (this.subject == "团体") {
          if (this.formData.list.length <= 0) {
            this.$root.$toast.fail("请添加团体成员");
            return;
          }else if(this.formData.list.length == 1){
            this.$root.$toast.fail("一个人请选择个人报名");
            return;
          }
        }
      }
      if (!this.promise) {
        this.$root.$toast.fail("请先阅读并同意 《作品原创承诺书》");
        return;
      }
      if (!this.mandate) {
        this.$root.$toast.fail("请先阅读并同意 《作品授权书》");
        return;
      }
      for(let k in this.formData.imgsArr){
        let imgsArr = this.formData.imgsArr[k]
        if(imgsArr.photo_file_list.length<1){
          this.$root.$toast.fail("请上传"+imgsArr.formatInfo+'格式文件');
          return
        }
        if(imgsArr.photo_file_list[0].status=="uploading"){
          this.$root.$toast.fail("图片或文件正在上传，请稍后再试。");
          return;
        }
      }
      if (this.photo_affix_list.length > 0 && this.photo_affix_list[0].status === "uploading") {
        this.$root.$toast.fail("图片或文件正在上传，请稍后再试。");
        return;
      }
      // 验证数据
      const dataValidate = () => {
        return new Promise((res) => {
          for (let key in this.formData) {
            if (key === "sourceFile") {
              if (this.sourceFileMust) {
                let pass = this.validate.isNull(key);
                if (!pass) {
                  this.$root.$toast.fail("请选择源文件附件");
                  res(false);
                } else {
                  res(true);
                }
              } else {
                res(true);
              }
            } else {
              console.log(this.formData,key)
              let pass = this.validate.isNull(key);
              if (!pass) res(false);
              this.$forceUpdate();
            }
          }
        });
      };
      const result = await dataValidate();
      console.log('执行',result)
      if(this.isCollection == 1){
        if(!this.formData.receivingUser || !this.formData.receivingPhone || !this.formData.receivingCode || !this.formData.receivingDetailAddress){
          return
        }
      }
      if (!this.formData.zoneId) {
        this.$root.$toast.fail("请选择赛区");
        return;
      }
      if (!result) {
        this.validate.errMsgPopup();
        this.validate.errMsgEmpty();
        return;
      } else {
        this.btndis = true;
        let {
          unitName,
          teacherName,
          teacherPhone,
          list,
          receivingUser,
          receivingPhone,
          receivingDetailAddress,
          receivingCode,
          teamName,
          mainBodyType,
          playerVal,
          majorVal,
          mail,
          phone,
          photo_title,
          province,
          zoneId,
		      zoneName,
          photo_desc,
          sourceFile,
          workId,
          imgsArr,
          schoolName
        } = this.formData;
        let imgs = [];
        imgsArr.map(K=>{
          if(K.photo_file_list[0].url){
            imgs.push(K.photo_file_list[0].url)
          }
        })
        const p = {
          babyName: this.formData2.babyName,
          // 后台小路不让传的
		      // idCardType:this.formData2.cardType,
          schoolName: schoolName,
          unitName: unitName || this.formData2.unitName,
          teacherName: teacherName || this.formData2.teacherName,
          teacherPhone: teacherPhone || this.formData2.teacherPhone,
          imgUrl: this.formData2.head,
          list,
          receivingUser,
          receivingPhone,
          receivingDetailAddress,
          receivingCode,
          teamName,
          mainBodyType,
          babyId: playerVal,
          email: mail,
          imgs,
          majorId: majorVal,
          name: photo_title,
          sourceFile,
          synopsis: photo_desc,
          tel: phone==this.formDataPhone?'':phone,
          workId,
          activityId: this.activityId,
          province: province,
          zoneId,
		      zoneName: zoneName,
        };
        p.teacherPhone = p.teacherPhone == this.formTeacherPhone?'':p.teacherPhone;
        updWorks(p).then((res) => {
          if (res.success) {
            // 报名成功
            this.$root.$toast.fail("修改成功");
            this.$router.go(-1);
          }
        });
      }
    },
    // 提交投稿信息
    async submitFn() {
      if(this.activityId==24){
        this.$root.$toast.fail("活动报名已结束");
        return 
      }
      if (this.model == 1) {
        if (this.subject == "团体") {
          if (this.formData.list.length <= 0) {
            this.$root.$toast.fail("请添加团体成员");
            return;
          }else if(this.formData.list.length == 1){
            this.$root.$toast.fail("一个人请选择个人报名");
            return;
          }
        }
      }
      for(let k in this.formData.imgsArr){
        let imgsArr = this.formData.imgsArr[k]
        if(imgsArr.photo_file_list.length<1){
          this.$root.$toast.fail("请上传"+imgsArr.formatInfo+'格式文件');
          return
        }
        if(imgsArr.photo_file_list[0].status=="uploading"){
          this.$root.$toast.fail("图片或文件正在上传，请稍后再试。");
          return;
        }
      }
      if (!this.promise) {
        this.$root.$toast.fail("请先阅读并同意 《作品原创承诺书》");
        return;
      }
      if (!this.mandate) {
        this.$root.$toast.fail("请先阅读并同意 《作品授权书》");
        return;
      }
      if (
        (this.photo_file_list.length > 0 &&
          this.photo_file_list[0].status === "uploading") ||
        (this.photo_affix_list.length > 0 &&
          this.photo_affix_list[0].status === "uploading")
      ) {
        this.$root.$toast.fail("图片或文件正在上传，请稍后再试。");
        return;
      }
      // 验证数据
      const dataValidate = () => {
        return new Promise((res) => {
          for (let key in this.formData) {
            if (key === "sourceFile") {
              if (this.sourceFileMust) {
                let pass = this.validate.isNull(key);
                if (!pass) {
                  this.$root.$toast.fail("请选择源文件附件");
                  res(false);
                } else {
                  res(true);
                }
              } else {
                res(true);
              }
            } else {
              let pass = this.validate.isNull(key);
              if (!pass) res(false);
              this.$forceUpdate();
            }
          }
        });
      };
      const result = await dataValidate();
      console.log('执行',result)
      if(this.isCollection == 1){
        if(!this.formData.receivingUser || !this.formData.receivingPhone || !this.formData.receivingCode || !this.formData.receivingDetailAddress){
          return
        }
      }
      if (!this.formData.zoneId) {
        this.$root.$toast.fail("请选择赛区");
        return;
      }
      if (!result) {
        this.validate.errMsgPopup();
        this.validate.errMsgEmpty();
        return;
      } else {
        this.btndis = true;
        const {
          unitName,
          teacherName,
          teacherPhone,
          list,
          receivingUser,
          receivingPhone,
          receivingDetailAddress,
          receivingCode,
          teamName,
          mainBodyType,
          playerVal,
          majorVal,
          mail,
          phone,
          photo_title,
          province,
		      zoneName,
          zoneId,
          photo_desc,
          imgsArr,
          sourceFile,
          schoolName
        } = this.formData;
        let imgs = [];
        imgsArr.map(K=>{
          if(K.photo_file_list[0].url){
            imgs.push(K.photo_file_list[0].url)
          }
        })
        const p = {
          institutionId: this.institutionId,
		      idCardType:this.formData2.cardType,
          schoolName: schoolName,
          unitName: unitName || this.formData2.unitName,
          teacherName: teacherName || this.formData2.teacherName || this.teacherName,
          teacherPhone: teacherPhone || this.formData2.teacherPhone || this.teacherTel,
          imgUrl: this.formData2.head,
          list,
          receivingUser,
          receivingPhone,
          receivingDetailAddress,
          receivingCode,
          teamName,
          mainBodyType,
          babyId: playerVal,
          email: mail,
          imgs,
          majorId: majorVal,
          name: photo_title,
          sourceFile,
          synopsis: photo_desc,
          activityId: this.activityId,
          tel: phone,
          province: province,
		      zoneName: zoneName,
          zoneId
        };
        activityEnroll(p).then((res) => {
          if (res.success) {
            // 报名成功
            this.applySuccess = true;
            this.worksId = res.data.id;
            setTimeout(() => {
              this.btndis = false;
            }, 2000);
          } else {
            setTimeout(() => {
              this.btndis = false;
            }, 2000);
          }
        });
      }
    },
    /**
     * @description: 获取标签流程
     * @param {*}
     * @return {*}
     * @author: wangxiaoheng
     */
    getLabel(){
      this.$router.push('/getLabel')
    },
    getknow(){
      this.$router.go(-1);
    },
    // 查看作品
    viewWorks() {
      // this.$root.mipLink("/player/photodetail", { id: this.worksId });
      this.$router.replace(`/player/photodetail?id=${this.worksId}`);
    },
  },
};
</script>
<style lang="scss" scoped>
.act-apl {
  min-height: 100vh;
  width: 100%;
  max-width: 10rem;
  // padding: 0 20px;
  background-color: #f9f9f9;
  .form-ipt {
    padding-bottom: 60px;
    .input {
      .reject {
        padding: 10px;
        color: red;
        p {
          margin: 5px 0;
          font-size: 14px;
        }
      }
      .van-cell {
        &::after {
          border: none;
        }
      }
      // padding: 0 20px;
      .van-cell__title {
        text-align: left;
      }
      .photo-upload,
      .file-upload {
        padding: 0 10px;
        background-color: #fff;
      }
    }
    .tips {
      padding-left: 100px;
      margin-top: 20px;
      .tip {
        display: flex;
        line-height: 22px;
        p {
          margin-left: 10px;
          font-size: 12px;
          color: #999;
          span {
            color: rgba(64, 158, 255, 0.7);
          }
        }
      }
    }
  }
  .apply-success {
    height: 100%;
    background-color: #fff;
    .tip-info {
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      img {
        margin-top: 55px;
      }
      .van-icon {
        font-size: 52px;
      }
      p {
        font-size: 18px;
        font-weight: 700;
        color: #666;
        margin-top: 14px;
        margin-bottom: 12px;
        padding: 0 40px;
        text-align: center;
      }
    }
    .view-btn {
      margin-top: 125px;
      display: flex;
      justify-content: center;
      .van-button {
        border-radius: 16px;
        width: 254px;
        height: 32px;
      }
    }
  }
  .consent-page {
    color: #333333;
    padding-bottom: 110px;
    h2 {
      text-align: center;
    }
    .container {
      padding: 0 20px;
      p {
        line-height: 32px;
        font-size: 14px;
        min-height: 32px;
      }
    }
    .consent-btn {
      position: fixed;
      bottom: 0;
      display: flex;
      align-items: center;
      justify-content: center;
      width: 100%;
      margin: 50px auto 30px auto;
      .van-button {
        border-radius: 16px;
        width: 254px;
        height: 32px;
      }
    }
  }
  .know{
    width: 209px;
    height: 40px;
    margin: 0 auto;
    margin-top: 30px;
    background: #83E38F;
    border-radius: 20px;
    font-size: 14px;
    font-family: PingFang SC;
    font-weight: bold;
    color: #FFFFFF;
  }
  .successTips{
    width: 330px;
    background: #F7F7FA;
    border-radius: 5px;
    margin: 0 auto;
    padding: 18px 12px;
    div{
      font-size: 13px;
      font-family: PingFang SC;
      font-weight: 400;
      color: #404046;
      line-height: 21px;
      margin-top: 20px;
    }
    div:first-child{
      margin-top: 0px;
    }
    span{
      color: #FF7856;
      text-decoration:underline;
    }
  }
}
</style>
<style lang="scss">
@import "../../assets/css/customer.scss";
.act-apl {
  text-align: left;
  .affixs-label {
    width: unset;
    & + .van-field__value {
      display: none;
    }
  }
  .input {
    .van-uploader {
      @include from-upload-style;
    }
  }
  .preview-cover {
    position: absolute;
    bottom: 0;
    box-sizing: border-box;
    width: 100%;
    padding: 4px;
    color: #fff;
    font-size: 12px;
    text-align: center;
    background: rgba(0, 0, 0, 0.3);
  }
  .submit {
    margin-top: 20px;
    display: flex;
    justify-content: center;
    .van-button {
      border-radius: 16px;
      width: 254px;
      height: 32px;
    }
  }
  .custom-tit {
    font-size: 12px;
    color: #cccccc;
  }
}
</style>
